import {
  Form, Flex, FlexItem, Button, TextInput,
  Grid, GridItem, HelperText,
} from '@patternfly/react-core';
import { EyeIcon, EyeSlashIcon } from '@patternfly/react-icons';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { login } from 'store/auth/authSlice';
import LoadingSpinner from 'ui/components/LoadingSpinner';

interface LoginPageProps {
  onLoginSuccess: () => void;
}

function LoginPage({ onLoginSuccess }: LoginPageProps) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    const success = await dispatch<any>(login(email, password));
    setLoading(false);
    if (success) {
      setErrorMessage('');
      onLoginSuccess();
      history.push(`/${localStorage.getItem('tenantId')}/employees`);
    } else {
      setErrorMessage('Usuario o contraseña inválida');
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <LoadingSpinner isLoading={loading} />
      <style>
        {`
          .row{
            display: flex;
          }
          
          .right-div {
            padding-rigth: 0 !important;
            padding-left: 0 !important;
          }
 
          .right-inside-div {
            display: flex !important;
            justify-content: center !important;
            align-items: center !important;
          }
 
          .w-50{
            width: 50% !important
          }
 
          .img-fluid{
            max-width: 100%;
            height: auto;
          }
 
          .left-div{
            height: 100vh !important;
            position: relative !important;
          }
 
          .left-inside-div{
            align-items: center !important;
            display: flex !important;
            justify-content: center !important;
          }
 
          @media (min-width: 576px) {
            .d-sm-block {
              display: block !important;
            }
 
            .col-sm-6 {
              flex: 0 0 auto;
              width: 50%;
            }
          }
 
          @media (min-width: 1025px) {
            .h-custom-2 {
                height: 100%;
            }
          }
        `}
      </style>
      <section>
        <div className="row">
          <div className="col-sm-6 left-div" style={{ backgroundColor: '#355d91' }}>
            <div className="left-inside-div h-custom-2">
              <Form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', width: '300px' }}>
                <h1 style={{
                  color: 'white',
                  textAlign: 'center',
                  fontWeight: 'bold',
                  fontSize: '25px',
                }}
                >
                  Iniciar Sesión
                </h1>
                <Flex>
                  <FlexItem
                    fullWidth={{ default: 'fullWidth' }}
                    style={{ paddingBottom: '10px' }}
                  >
                    <Grid>
                      <GridItem>
                        <TextInput
                          type="text"
                          placeholder="Correo electrónico"
                          value={email}
                          onChange={(e) => setEmail(e)}
                          required
                          style={{ borderRadius: '0.5rem' }}
                        />
                      </GridItem>
                    </Grid>
                  </FlexItem>
                  <FlexItem
                    fullWidth={{ default: 'fullWidth' }}
                    style={{ paddingBottom: '10px' }}
                  >
                    <Grid>
                      <GridItem>
                        <div style={{ position: 'relative' }}>
                          <TextInput
                            type={showPassword ? 'text' : 'password'}
                            placeholder="Contraseña"
                            value={password}
                            onChange={(e) => setPassword(e)}
                            required
                            style={{ borderRadius: '0.5rem', paddingRight: '2.5rem' }}
                          />
                          <button
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                            style={{
                              position: 'absolute',
                              right: '0.75rem',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              background: 'transparent',
                              border: 'none',
                              cursor: 'pointer',
                              padding: 0,
                            }}
                            aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                          >
                            {showPassword ? (
                              <EyeSlashIcon style={{ width: '1.25rem', height: '1.25rem', color: '#6a6e73' }} />
                            ) : (
                              <EyeIcon style={{ width: '1.25rem', height: '1.25rem', color: '#6a6e73' }} />
                            )}
                          </button>
                        </div>
                      </GridItem>
                    </Grid>
                  </FlexItem>
                  <FlexItem>
                    <HelperText style={{ color: 'red' }}>
                      {errorMessage}
                    </HelperText>
                  </FlexItem>
                  <FlexItem
                    fullWidth={{ default: 'fullWidth' }}
                    style={{ textAlign: 'center' }}
                  >
                    <Grid>
                      <GridItem>
                        <Button
                          type="submit"
                          style={{
                            backgroundColor: 'white',
                            borderRadius: '0.5rem',
                            color: '#355d91',
                          }}
                          variant="secondary"
                        >
                          Ingresar
                        </Button>
                      </GridItem>
                    </Grid>
                  </FlexItem>
                </Flex>
              </Form>
            </div>
          </div>
          <div className="right-div d-sm-block col-sm-6">
            <div className="right-inside-div" style={{ height: '100%' }}>
              <img
                src="/assets/images/Logotipo_SITE_kronex-21.png"
                alt="Login"
                className="w-50 img-fluid"
                style={{ objectFit: 'cover', objectPosition: 'left' }}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default LoginPage;
